const env = window.BETCLOUD_ENV || process.env;

export const isSweeps = !!env.REACT_APP_API_URL.includes('sweeps');
